import React, { useEffect, useState } from "react";
import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../hocs/with_show_toast.js';
import { compose } from 'redux';

import PageContainer from "./components/page_container.js";
import BackButtonBlock from "./components/back_button_block.js";
import NavBlock from "./components/nav_block.js";
import Form from "./components/form.js";
import FormWrapper from "./components/form_wrapper.js";
import Title from "./components/title.js";
import SubmitButton from "./components/submit_button.js";
import LoadingIndicator from "./components/loading_indicator.js";

import I18n from "../../../base/i18n.js.jsx";
import PaymentMethodFields from "../../../base/user_fields/payment_method_fields.js";

import CurrentUserPaymentMethodUseCase from "../../../use_cases/users/payment_methods/current_user_payment_method_use_case.js";
import UpdateCurrentUserPaymentMethodUseCase from "../../../use_cases/users/payment_methods/update_current_user_payment_method_use_case.js";

const ProfilePaymentMethodPage = (props) => {
  const { showSuccessMessage, showServerErrorIfNeed } = props;

  const [loading, setLoading] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState({});
  const [errorData, setErrorData] = useState(undefined);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    CurrentUserPaymentMethodUseCase.execute()
    .then((result) => {
      const { data: { paymentMethod } } = result;
      setPaymentMethod(paymentMethod);
      setLoading(false);
    })
    .catch((result) => {
      setLoading(false);
      showServerErrorIfNeed(result);
    })
  }, []);

  const onChange = (paymentMethod) => {
    setPaymentMethod(paymentMethod);
  }

  const onSubmit = () => {
    setErrorData(undefined);
    setSubmitting(true);
    UpdateCurrentUserPaymentMethodUseCase.execute(paymentMethod)
    .then((result) => {
      const { data: { paymentMethod } } = result;
      setPaymentMethod(paymentMethod);
      setSubmitting(false);
      showSuccessMessage(I18n.t("shared.toast.successfully_saved"));
    })
    .catch((result) => {
      const { errorData } = result;
      setErrorData(errorData);
      setSubmitting(false);
      showServerErrorIfNeed(result);
    })
  }

  return (
    <PageContainer>
      <Title />
      <NavBlock needReplace = { true } />
      <FormWrapper>
        <BackButtonBlock />
        <Form onSubmit = { onSubmit } >
          { loading && <LoadingIndicator /> }
          {
            !loading && 
            <PaymentMethodFields paymentMethod = { paymentMethod } 
                                 onChange = { onChange }
                                 showDisclaimer = { true } 
                                 errorData = { errorData }/>
          }
          <SubmitButton disabled = { loading || submitting } />
        </Form>
      </FormWrapper>
    </PageContainer>
  );
}

export default compose(withShowToast, withCurrentUser, withRouter)(ProfilePaymentMethodPage);
